export const SOFTLINE_API_DELIVERY_NOTE_ROSTER_ORDERS =
  'roster-delivery-service/commerce/roster-delivery/orders';
export const SOFTLINE_API_DELIVERY_NOTE_ROSTER_PURCHASE_ORDERS =
  'roster-delivery-service/commerce/roster-delivery/purchase-orders';

export const SOFTLINE_API_DELIVERY_NOTE_ROSTER_STRUCTURE =
  'roster-delivery-service/commerce/roster-delivery/roster/structure';
export const SOFTLINE_API_DELIVERY_NOTE_ROSTER_CONTENT =
  'roster-delivery-service/commerce/roster-delivery/roster/content';

export const SOFTLINE_API_DELIVERY_NOTE_ROSTER_UPDATE_ENTRY =
  'roster-delivery-service/commerce/roster-delivery/roster/content/{{id}}';
export const SOFTLINE_API_DELIVERY_NOTE_ROSTER_DELETE_ENTRY =
  'roster-delivery-service/commerce/roster-delivery/roster/content/delete';

export const SOFTLINE_API_DELIVERY_NOTE_ROSTER_IMPORT =
  'roster-delivery-service/commerce/roster-delivery/roster/importData';
export const SOFTLINE_API_DELIVERY_NOTE_ROSTER_EXPORT =
  'roster-delivery-service/commerce/roster-delivery/roster/exportData';
export const SOFTLINE_API_DELIVERY_NOTE_ROSTER_MAIL =
  'roster-delivery-service/commerce/roster-delivery/roster/content/{{id}}/send';
